import { stateful } from '@adornis/functional-lit/stateful.js';
import { useQuery } from '@adornis/functional-lit/use-query.js';
import { GlobalConfigAPI } from '@martinus/global-config/api/GlobalConfigAPI.js';
import { format } from 'date-fns';
import { html } from 'lit';
import version from '../../../../../../version.json' with { type: 'json' };
import { UsageAPI } from '../../api/UsageAPI.js';
import {
  renderDashboardCardHeader,
  renderDashboardLoadingCard,
  renderLiveBadge,
  renderReadableInteger,
  renderUptime,
} from './StatRenderUtilities.js';

export const SystemStatsSection = stateful(() => {
  const { value: serverTime, loading: serverTimeLoading } = useQuery(() => UsageAPI.serverTime()(), []);
  const { value: activeSessions, loading: activeSessionsLoading } = useQuery(() => UsageAPI.activeSessions()(), []);
  const { value: config, loading: configLoading } = useQuery(() => GlobalConfigAPI.subscribe()({ lastDeploy: 1 }), []);

  if (serverTimeLoading || activeSessionsLoading || configLoading) {
    return renderDashboardLoadingCard();
  }

  return html`
    <div class="card h-full">
      <div class="card-body gap-4">
        ${renderDashboardCardHeader('System', 'icon-[material-symbols--dns-outline-rounded]', renderLiveBadge())}

        <div class="stats stats-vertical w-full sm:stats-horizontal">
          <div class="stat">
            <div class="stat-figure text-base-content/40">
              <span class="icon-[material-symbols--timer-outline-rounded] size-8"></span>
            </div>
            <div class="stat-title">Laufzeit</div>
            <div class="stat-value text-2xl">${renderUptime(config?.lastDeploy)}</div>
            <div class="stat-desc">
              ${config?.lastDeploy ? `Neustart am ${format(config.lastDeploy, 'dd.MM.yyyy HH:mm')}` : 'Kein Neustart bekannt'}
            </div>
          </div>
          <div class="stat">
            <div class="stat-figure text-base-content/40">
              <span class="icon-[material-symbols--group-outline-rounded] size-8"></span>
            </div>
            <div class="stat-title">Aktive Sessions</div>
            <div class="stat-value text-2xl">${renderReadableInteger(activeSessions ?? 0)}</div>
          </div>
        </div>

        <dl class="grid gap-x-4 gap-y-1 sm:grid-cols-[max-content_1fr]">
          <dt class="text-sm font-semibold text-base-content/70">Version</dt>
          <dd>${version.release} (${version.commit})</dd>
          <dt class="text-sm font-semibold text-base-content/70">Build</dt>
          <dd>${format(new Date(version.date), 'dd.MM.yyyy HH:mm:ss')}</dd>
          <dt class="text-sm font-semibold text-base-content/70">Serverzeit</dt>
          <dd class="tabular-nums">${serverTime}</dd>
        </dl>
      </div>
    </div>
  `;
});
